__turbopack_context__.v({
  "amount": "mn6KRG_amount",
  "black": "mn6KRG_black",
  "card": "mn6KRG_card",
  "gl": "mn6KRG_gl",
  "gold": "mn6KRG_gold",
  "mark": "mn6KRG_mark",
  "markFill": "mn6KRG_markFill",
  "markHighlight": "mn6KRG_markHighlight",
  "markShadow": "mn6KRG_markShadow",
  "silver": "mn6KRG_silver",
  "t1": "mn6KRG_t1",
  "t2": "mn6KRG_t2",
  "tag": "mn6KRG_tag",
});
